import { Component, computed, inject, signal } from '@angular/core';
import { Router } from '@angular/router';

import { finalize } from 'rxjs';

import {
  ConfirmationModalData,
  ConfirmationModalService
} from '@app/core/services/confirmation-modal.service';
import { ButtonComponent } from '@app/core/ui/components/button';
import { ModalService } from '@app/core/ui/components/modal';
import { MODAL_DATA } from '@app/core/ui/components/modal/modal.component';
import { ToastService } from '@app/core/ui/components/toast';
import { SafeTransformPipe } from '@app/shared/pipes/safe-transform.pipe';
import { customCatchError } from '@app/shared/rxjs/custom-operators';

export type ConfirmationModalInput = Omit<ConfirmationModalData, 'title'>;

@Component({
  selector: 'mw-confirmation-modal',
  imports: [SafeTransformPipe, ButtonComponent],
  templateUrl: './confirmation-modal.component.html',
  styleUrl: './confirmation-modal.component.scss'
})
export class ConfirmationModalComponent {
  private readonly data = signal(inject<ConfirmationModalInput>(MODAL_DATA));
  private readonly modal = inject(ModalService);
  private readonly router = inject(Router);
  private readonly confirmationModal = inject(ConfirmationModalService);
  private readonly toast = inject(ToastService);

  protected readonly content = computed(() => this.data().content ?? '');
  protected readonly cta = computed(
    () => this.data().cta ?? { name: 'Continuar', link: undefined }
  );
  protected readonly confirming = signal(false);

  handleCloseModal() {
    if (this.confirming()) {
      return;
    }
    const id = this.data().id;
    this.confirming.set(true);
    this.confirmationModal
      .markAsSeen(id)
      .pipe(
        finalize(() => this.confirming.set(false)),
        customCatchError(({ message }) => {
          this.toast.show(message ?? 'Erro ao confirmar. Tente novamente.', {
            variant: 'danger'
          });
          this.modal.close();
        })
      )
      .subscribe(() => {
        if (this.cta().link) {
          this.router.navigateByUrl(this.cta().link);
        } else {
          this.modal.close();
        }
      });
  }
}
